/* eslint-disable react/prefer-stateless-function */
import Modal from './modal';
import React from 'react';

class MediumModal extends React.Component {

    render() {

        const props = { ...this.props, size: 'medium' };

        return (
            <Modal {...props} />
        );

    }

}

export default MediumModal;
